<template>
  <div class="login">
    <div class="login__container">
      <img src="/static/images/logo.png" alt="Logotipo CMS" class="login__logo">
      <h1 class="login__title">Cambiar contraseña</h1>
      <p class="login__text">Utiliza aquí el código que te enviamos y crea una nueva contraseña para tu cuenta</p>
      <form class="form" @submit.prevent="reset">
        <div class="form__fieldset">
          <div class="form__container">
            <label for="email" class="form__label form__label--hidden">Correo Electrónico</label>
            <input type="text" class="form__input" name="email" id="email" v-model="access.email" placeholder="Correo electrónico" v-validate="validation.email">
            <span v-show="errors.has('email')" class="form__alert" v-text="errors.first('email')"></span>
          </div>
          <div class="form__container">
            <label for="code" class="form__label form__label--hidden">Código</label>
            <input type="password" class="form__input" name="code" id="code" v-model="access.code" placeholder="Código de recuperación" v-validate="validation.code">
            <span v-show="errors.has('code')" class="form__alert" v-text="errors.first('code')"></span>
          </div>
          <div class="form__container">
            <label for="password" class="form__label form__label--hidden">Contraseña</label>
            <input ref="password" type="password" class="form__input" name="password" id="password" v-model="access.password" placeholder="Contraseña" v-validate="validation.password">
            <span v-show="errors.has('password')" class="form__alert" v-text="errors.first('password')"></span>
          </div>
          <div class="form__container">
            <label for="confirm_password" class="form__label form__label--hidden">Repetir contraseña</label>
            <input type="password" class="form__input" name="confirm_password" id="confirm_password" v-model="access.confirm_password" placeholder="Repetir contraseña" v-validate="validation.confirm_password" data-vv-as="password">
            <span v-show="errors.has('confirm_password')" class="form__alert" v-text="errors.first('confirm_password')"></span>
          </div>
        </div>
        <input type="submit" class="btn btn__action btn--regular" value="Cambiar contraseña e ingresar">
        <router-link :to="{name: 'signIn'}" class="btn btn__transparent btn--regular">Volver al inicio de sesión</router-link>
      </form>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import {auth} from '@/core/libs/sessions'
export default {
  name: 'resetLogin',
  mixins: [
    httpService
  ],
  data: function () {
    return {
      access: {
        email: null,
        code: null,
        password: null,
        confirm_password: null
      },
      validation: {
        email: 'required|email',
        code: 'required|numeric|min_value:100000|max:6',
        password: 'required|min:6',
        confirm_password: 'required|min:6|confirmed:password'
      }
    }
  },
  methods: {
    reset: function () {
      this.$validator.validateAll()
        .then(
          result => {
            if (result) {
              let httpRequest = {
                params: '',
                module: 'reset',
                element: this.access
              }
              this.post(httpRequest)
                .then(
                  reset => {
                    auth.setSession(reset)
                      .then(
                        response => {
                          this.$store.commit('login', true)
                          this.$router.push({name: 'home'})
                          this.$store.commit('notificate', {
                            title: 'CONTRASEÑA CAMBIADA',
                            text: 'Su contraseña ha sido cambiada exitosamente, bienvenido a nuestro panel',
                            type: 'success'
                          })
                        }
                      )
                  }
                ).catch(
                  () => {
                    this.$store.commit('notificate', {
                      title: 'HA OCURRIDO UN ERROR',
                      text: 'Ocurrio un error al realizar el cambio de su contraseña, verifique que el código es valido y no ha expirado',
                      type: 'warn'
                    })
                  }
                )
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/components/_login"
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/login/reset.vue